module.exports = __webpack_public_path__ + "img/dhm-logo.78c9f2d8.png";